import { useScrollToTop } from './common/Hooks/useScrollToTop';

export const ScrollToTop = () => {
  useScrollToTop();
  return null;
};
